import * as React from 'react';
import { DataLayer } from '@grandvisionhq/analytics';
import { useAccount, State } from '@grandvisionhq/auth';
import { Text } from '@grandvisionhq/elements';
import { useCartStorage } from '@grandvisionhq/lib-utils-cart';
import { useFeatureToggles, useIntl } from '@grandvisionhq/state';
import { useCart } from '../../../../context/Cart/context.js';
import '@swc/helpers';
import '@grandvisionhq/common';
import '@grandvisionhq/graphql';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/utils';
import '../../../../context/CartSettings/context.js';
import '../../../../models/add-to-cart/add-to-cart.js';
import '../../../../models/cart/cart.js';
import '../../../../models/checkoutState/checkoutState.js';
import '../../../../utils/cart-count-var.js';
import '../../../../utils/cart-id-var.js';
import '@grandvisionhq/commercetools';
import '../../../../utils/get-unrecoverable-validation-errors.js';
import '../../../../models/line-item/prescription-glasses.js';
import '../../../../utils/get-failure-error-codes.js';
import '../../../../utils/get-validation-errors-by-line-item.js';
import '@grandvisionhq/lib-visuals';
import '../../../../operations/fragments/cart-details.js';
import '../../../../operations/fragments/cart-validation-errors.js';
import '../../../../operations/fragments/recover-inactive-cart-failure.js';
import '../../../../operations/fragments/recover-inactive-cart-result.js';
import '../../../../operations/mutations/add-cart-line-items.js';
import '../../../../operations/mutations/add-cart-voucher-codes.js';
import '../../../../operations/mutations/create-cart.js';
import '../../../../operations/mutations/create-cart-from-instant-checkout-link.js';
import '../../../../operations/mutations/create-cart-from-order.js';
import '../../../../operations/mutations/duplicate-cart-line-items.js';
import '../../../../operations/mutations/remove-cart-voucher-codes.js';
import '../../../../operations/mutations/remove-cart-line-items.js';
import '../../../../operations/mutations/update-cart-line-items.js';
import '../../../../operations/mutations/recover-inactive-cart.js';
import '../../../../operations/queries/get-cart.js';
import '../../../../operations/queries/get-total-line-items.js';
import '../../../../operations/queries/get-cart-estimated-delivery.js';
import { mapCartDataToExpressInit } from '../../../../mappers/analytics/data-layer/express-init-mapper.js';
import '../../../../mappers/analytics/tealium/line-item-to-tealium-product.js';
import { ExpressActionContainer } from '../../containers/ExpressActionContainer/ExpressActionContainer.js';
import { FixCartButtonContainer } from '../../containers/FixCartButtonContainer/FixCartButtonContainer.js';

const Navigation = ({ labels , unavailableLineItems , hasSubscription , handleCheckoutNavigation  })=>{
    const { isMyAccountEnabled  } = useFeatureToggles();
    const authState = useAccount();
    const isLoggedIn = isMyAccountEnabled && authState === State.AuthState.LoggedIn;
    const [{ cartId  }] = useCartStorage();
    const { cart  } = useCart();
    const [isOrderInProgress, setIsOrderInProgress] = React.useState(false);
    const { getLabel  } = useIntl();
    const handleInitExpressDataLayerEvent = React.useCallback((paymentMethod)=>{
        if (cart && authState) {
            const eventData = mapCartDataToExpressInit(cart, paymentMethod, isLoggedIn);
            DataLayer.pushEcommerceEvent(eventData);
        }
    }, [
        cart,
        authState,
        isLoggedIn
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: "cart-navigation"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "checkout-button-container"
    }, !(unavailableLineItems === null || unavailableLineItems === void 0 ? void 0 : unavailableLineItems.length) && cartId && /*#__PURE__*/ React.createElement(React.Fragment, null, isOrderInProgress && /*#__PURE__*/ React.createElement(Text, {
        className: "payment-form-container__instruction"
    }, getLabel(`checkout.express.payment.wait.instruction`)), !isOrderInProgress && /*#__PURE__*/ React.createElement(ExpressActionContainer, {
        hasSubscription: hasSubscription,
        isOrderInProgress: isOrderInProgress,
        setIsOrderInProgress: setIsOrderInProgress,
        onClickHandler: handleInitExpressDataLayerEvent
    })), !isOrderInProgress && /*#__PURE__*/ React.createElement(FixCartButtonContainer, {
        handleCheckoutNavigation: handleCheckoutNavigation,
        labels: labels,
        unavailableLineItems: unavailableLineItems,
        isLoggedIn: isLoggedIn
    })));
};

export { Navigation };
//# sourceMappingURL=Navigation.js.map
